"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeywordRefMappingListResponseSchema = exports.KeywordRefMappingResponseSchema = exports.KeywordRefListSchema = exports.FindByPlatformRefResponseSchema = exports.FindByPlatformRefInfoSchema = exports.FindByPlatformRefQuerySchema = exports.ExportTeamResponseSchema = exports.ExportCampaignResponseSchema = exports.ExportChannelSchema = exports.ExportTeamQuerySchema = exports.ExportCampaignQuerySchema = exports.ExportChannelRegionSchema = exports.ExportChannelNegativeKeywordSchema = exports.ExportChannelSeedKeywordSchema = exports.ExportChannelTargetingKeywordSchema = exports.ExportChannelRegionNegativeKeywordSchema = exports.ExportChannelRegionTargetingKeywordSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const api_1 = require("../api");
const ExportMetadataFields = {
    createdAt: core_1.TimestampSchema,
    updatedAt: core_1.TimestampSchema,
};
const OptionalExportMetadataFields = {
    createdAt: typebox_1.Type.Optional(core_1.TimestampSchema),
    updatedAt: typebox_1.Type.Optional(core_1.TimestampSchema),
};
exports.ExportChannelRegionTargetingKeywordSchema = (0, core_1.StrictObject)({
    keywordId: core_1.IdSchema,
    adGroupRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    keywordRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    forceBidAmount: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    minBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    maxBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    bidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    status: ruby_1.AppleChannelKeywordStatusSchema,
    ...OptionalExportMetadataFields,
});
exports.ExportChannelRegionNegativeKeywordSchema = (0, core_1.StrictObject)({
    keywordId: core_1.IdSchema,
    adGroupRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    keywordRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    status: ruby_1.AppleChannelKeywordStatusSchema,
    ...OptionalExportMetadataFields,
});
exports.ExportChannelTargetingKeywordSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    status: ruby_1.AppleChannelKeywordStatusSchema,
    ...ExportMetadataFields,
});
exports.ExportChannelSeedKeywordSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    status: ruby_1.AppleChannelKeywordStatusSchema,
    ...ExportMetadataFields,
});
exports.ExportChannelNegativeKeywordSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    keywordRefs: typebox_1.Type.Optional(typebox_1.Type.Array((0, core_1.StrictObject)({
        campaignRef: ruby_1.AppleProxyRefSchema,
        keywordRef: ruby_1.AppleProxyRefSchema,
    }))),
    match: ruby_1.KeywordMatchTypeSchema,
    text: ruby_1.KeywordSchema,
    status: ruby_1.AppleChannelKeywordStatusSchema,
    ...ExportMetadataFields,
});
exports.ExportChannelRegionSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    country: core_1.CountrySchema,
    purpose: ruby_1.PurposeSchema,
    orgRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    campaignRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    weighting: core_1.WeightingSchema,
    cpdGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    defaultBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    cpdDetails: typebox_1.Type.Optional(api_1.AppleRegionCpdDetailsSchema),
    targetEvent: typebox_1.Type.Optional(ruby_1.AttributionEventNameSchema),
    targetEventGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    targetRoas: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    targetRoasGoal: typebox_1.Type.Optional(core_1.UnderOrOverPercentageSchema),
    targetRoasTimeRange: typebox_1.Type.Optional(typebox_1.Type.Number()),
    targetingKeywords: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ExportChannelRegionTargetingKeywordSchema)),
    negativeKeywords: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ExportChannelRegionNegativeKeywordSchema)),
    ...ExportMetadataFields,
});
const ExportQuerySchema = {
    campaignRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    targetingKeywords: typebox_1.Type.Boolean({
        default: false,
    }),
    seedKeywords: typebox_1.Type.Boolean({
        default: false,
    }),
    negativeKeywords: typebox_1.Type.Boolean({
        default: false,
    }),
    regionKeywords: typebox_1.Type.Boolean({
        default: false,
    }),
    defaultBidAmount: typebox_1.Type.Boolean({
        default: false,
    }),
};
exports.ExportCampaignQuerySchema = (0, core_1.StrictObject)(ExportQuerySchema);
exports.ExportTeamQuerySchema = (0, core_1.StrictObject)({
    ...ExportQuerySchema,
    channelStatus: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleChannelStatusSchema)),
    regionStatus: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleChannelRegionStatusSchema)),
});
exports.ExportChannelSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    channelType: ruby_1.ChannelTypeSchema,
    keywordBidStrategy: ruby_1.KeywordBidStrategySchema,
    structure: ruby_1.ChannelStructureSchema,
    organisationRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    applicationRef: apple_proxy_web_1.AppleProxyAdamRefSchema,
    currency: core_1.CurrencySchema,
    storefront: typebox_1.Type.Optional(core_1.CountrySchema),
    seedKeywords: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ExportChannelSeedKeywordSchema)),
    negativeKeywords: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ExportChannelNegativeKeywordSchema)),
    targetingKeywords: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ExportChannelTargetingKeywordSchema)),
    regions: typebox_1.Type.Array(exports.ExportChannelRegionSchema),
    ...ExportMetadataFields,
    bidUpdateTimes: typebox_1.Type.Array(typebox_1.Type.Number()),
    keywordSources: typebox_1.Type.Array(ruby_1.KeywordSourceSchema),
    status: typebox_1.Type.String(),
    useLifetimeBudget: typebox_1.Type.Boolean(),
});
exports.ExportCampaignResponseSchema = (0, core_1.StrictObject)({
    campaignId: core_1.IdSchema,
    channels: typebox_1.Type.Array(exports.ExportChannelSchema),
});
exports.ExportTeamResponseSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    teamCampaigns: typebox_1.Type.Array(exports.ExportCampaignResponseSchema),
});
exports.FindByPlatformRefQuerySchema = (0, core_1.StrictObject)({
    campaignRef: ruby_1.PlatformCampaignRefSchema,
    adGroupRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
});
exports.FindByPlatformRefInfoSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    channelType: ruby_1.ChannelTypeSchema,
    status: ruby_1.AppleChannelStatusSchema,
    structure: ruby_1.ChannelStructureSchema,
    currency: core_1.CurrencySchema,
    // These might not be present if the rely on other details like as adGroupRef and can't be decided
    regionId: typebox_1.Type.Optional(core_1.IdSchema),
    country: typebox_1.Type.Optional(core_1.CountrySchema),
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
});
exports.FindByPlatformRefResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.FindByPlatformRefInfoSchema);
exports.KeywordRefListSchema = (0, core_1.StrictObject)({
    keywordRefs: typebox_1.Type.Array(core_1.IdSchema),
});
exports.KeywordRefMappingResponseSchema = (0, core_1.StrictObject)({
    keywordRef: core_1.IdSchema,
    text: ruby_1.KeywordSchema,
    country: core_1.CountrySchema,
});
exports.KeywordRefMappingListResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.KeywordRefMappingResponseSchema);
